import AppStyleDecider from '../../../../../../../../../../baseComponents/AppsStyleDecider'
import { WorkSheetButtonsFinished, WorkSheetButtonsProps } from '../../../WorkSheetButtons'
import WorkSheetStatusBar, { WorkSheetCreateStatusBarProps, WorkSheetStatusBarNew } from '../../WorkSheetStatusBar'

type SingleWorkSheetHeaderReadOnlyDeciderProps = WorkSheetButtonsProps & WorkSheetCreateStatusBarProps & {}

const SingleWorkSheetHeaderReadOnlyDecider: React.FC<SingleWorkSheetHeaderReadOnlyDeciderProps> = ({...rest}) => {
    return <AppStyleDecider DefaultComponent={SingleWorkSheetHeaderReadOnlyDefault} NewComponent={SingleWorkSheetHeaderReadOnlyNew} {...rest} />
}

const SingleWorkSheetHeaderReadOnlyDefault: React.FC<SingleWorkSheetHeaderReadOnlyDeciderProps> = ({...rest}) => {
    return (
        <div className='flex gap-10 justify-between flex-wrap items-center flex-auto'>
            <WorkSheetStatusBar {...rest} />
            <WorkSheetButtonsFinished {...rest} />
        </div>
    )
}

const SingleWorkSheetHeaderReadOnlyNew: React.FC<SingleWorkSheetHeaderReadOnlyDeciderProps> = ({...rest}) => {
    return (
        <div className='flex gap-10 justify-between flex-wrap items-center flex-auto'>
            <WorkSheetStatusBarNew {...rest} />
            <WorkSheetButtonsFinished {...rest} />
        </div>
    )
}

export default SingleWorkSheetHeaderReadOnlyDecider